/**
 * @param {Function} fn 防抖函数
 * @param {Number} delay 延迟时间
 */
export function debounce(fn, delay) {
  var timer;
  return function () {
    var context = this;
    var args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
}

/**
 * @param {date} time 需要转换的时间
 * @param {String} fmt 需要转换的格式 如 yyyy-MM-dd、yyyy-MM-dd HH:mm:ss
 */
export function formatTime(time, fmt) {
  if (!time) return '';
  else {
    const date = new Date(time);
    const o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'H+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds(),
      'q+': Math.floor((date.getMonth() + 3) / 3),
      S: date.getMilliseconds(),
    };
    if (/(y+)/.test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        (date.getFullYear() + '').substr(4 - RegExp.$1.length)
      );
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          RegExp.$1.length === 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        );
      }
    }
    return fmt;
  }
}

export const numberToMoney = (number,decimal) => {
  let tmp = number.toFixed(decimal);
  tmp = parseFloat(tmp);
  tmp = tmp.toLocaleString();
  return tmp;
}

/**
 * @description: 获取当前 location 的参数
 */
// 直接解析 URL 的方法（不依赖 Vue Router）
export const getQueryParamsByName = (queryName) => {
  const href = window.location.href;
  return (getQueryParams(href))[queryName];
};

/**
 * @description: 获取地址栏参数组成对象
 * @param url 地址
 * @returns 
 */
export function getQueryParams(url) {
  const startIndex = url.indexOf('?');
  if (startIndex === -1) return {};
  const queryString = url.slice(Math.max(0, startIndex + 1));
  const params = new URLSearchParams(queryString);
  const result = {};
  for (const [key, value] of params) {
    result[key] = value;
  }
  return result;
}
